const pollerIds = {};

export const startPolling = (name, call, interval) => {
  if (pollerIds[name]) {
    console.log('already polling');
  } else {
    // do initial call
    call();
    // start polling
    pollerIds[name] = setInterval(call, interval);

    console.debug(
      'starting polling on ' + name,
      'pollerIds[name]: ',
      pollerIds[name]
    );
  }
};

export const stopPolling = (name) => {
  console.log(
    'stopping polling on ',
    name,
    'pollerIds[name]: ',
    pollerIds[name]
  );
  clearInterval(pollerIds[name]);
  pollerIds[name] = null;
};
